import axios from 'axios';
import { IPublicUser } from '@sravni/types/lib/auth';
import { sendSentryClientError } from '../logger';

export class ProfileProvider {
    constructor(protected path: string) {}

    update = async (data: FE.FormData, userId?: string | number) => {
        try {
            const { data: result } = await axios.post<boolean>(
                `${this.path}/profile/update/${userId ? `?userId=${userId}` : ''}`,
                data,
            );
            return result;
        } catch (e) {
            // если не смогли сохранить профиль пользователя, логируем ошибку как фатальную
            sendSentryClientError(
                e as Error,
                {
                    data,
                    userId,
                },
                { level: 'fatal' },
            );
            return false;
        }
    };

    loadWhitelabelData = async () => {
        try {
            const { data } = await axios.get<{ user: IPublicUser }>(`${this.path}/profile/restoreWhiteLabelUserData/`, {
                withCredentials: true,
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
            return data;
        } catch (e) {
            return null;
        }
    };
}
